
import store from '../store/store';
import { firebase } from '../config/firebase.client';
import { GetTripDistance } from '../other/GeoFunctions';
import { IBookingType, ISettingsType } from "../types";
import { FareCalculator } from '../other/FareCalculator';
import { fetchBookingLocations } from './locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { get, onValue, update, off, remove, push, query, orderByKey } from "firebase/database";
import { CANCEL_BOOKING, FETCH_BOOKINGS, UPDATE_BOOKING, FETCH_BOOKINGS_SUCCESS, FETCH_BOOKINGS_FAILED } from "../store/types";

export const addActualsToBooking = async (booking: any) => {
  const { settingsRef, trackingRef } = firebase;
  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  const end_time = new Date();
  const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
  const totalTimeTaken = Math.abs(Math.round(diff));
  if (settings.prepaid) {
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;
  } else {
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;
    let cars = store.getState().cartypes.cars;
    let rates: any = {};
    for (var i = 0; i < cars.length; i++) {
      if (cars[i].name == booking.carType) {
        rates = cars[i];
      }
    }


    const findCity = rates?.cities?.find(
      ({ city }: any) => {
        let formatCity = city.split(" - ");

        if (booking.pickup.add.includes(formatCity[0])) {
          return city;
        }
      }
    );

    if (findCity) {
      rates = {
        ...rates,
        min_fare: findCity.min_fare,
        base_fare: findCity.base_fare,
        rate_per_hour: findCity.rate_per_hour,
        convenience_fees: findCity.convenience_fees,
        rate_per_unit_distance: findCity.rate_per_unit_distance,
      };
    }


    const trackingSnap = await get(query(trackingRef(booking.id), orderByKey()));
    const trackingVal = trackingSnap.val();
    const res = await GetTripDistance(trackingVal);
    const distance = settings.convert_to_mile
      ? res.distance / 1.609344
      : res.distance;

    const { convenience_fees, totalCost } = FareCalculator(
      distance,
      totalTimeTaken,
      rates,
      undefined,
      settings.decimal
    );

    booking.trip_cost = totalCost;
    booking.distance = parseFloat(distance as any).toFixed(settings.decimal);
    booking.convenience_fees = convenience_fees;
    booking.driver_share = (totalCost - booking.convenience_fees).toFixed(
      settings.decimal
    );
    booking.coords = res.coords;
  }
  return booking;
};

export const fetchBookings = () => (dispatch: any) => {
  try {
    const {
      bookingListRef,
    } = firebase;

    dispatch({
      type: FETCH_BOOKINGS,
      payload: null,
    });

    const userInfo = store.getState().auth.profile;

    off(bookingListRef(userInfo.uid, userInfo.usertype));

    onValue(bookingListRef(userInfo.uid, userInfo.usertype), (snapshot) => {
      if (snapshot.val()) {
        let data: IBookingType[] = snapshot.val();

        if (userInfo?.usertype === 'fleetadmin') {
          data = Object.values(data).filter((booking) => {
            return booking.fleetadmin && booking.fleetadmin.includes(userInfo.uid);
          });
        }
        const active = [];
        let tracked = null;
        const bookings = Object.keys(data)
          .map((i: any) => {
            data[i].id = i;
            data[i].dropAddress = data[i].drop.add;
            data[i].pickupAddress = data[i].pickup.add;
            data[i].discount = data[i].discount ? data[i].discount : '0';
            data[i].cashPaymentAmount = data[i].cashPaymentAmount ? data[i].cashPaymentAmount : 0;
            data[i].cardPaymentAmount = data[i].cardPaymentAmount ? data[i].cardPaymentAmount : 0;
            return data[i];
          });
        for (let i = 0; i < bookings.length; i++) {
          const baseStatus = ['PAYMENT_PENDING', 'NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING'];

          // if (userInfo?.usertype === "customer") {
          //   if (baseStatus.indexOf(bookings[i].status) != -1) {
          //     active.push(bookings[i]);
          //   }
          // } else {
          if ([...baseStatus, 'PAID'].indexOf(bookings[i].status) != -1) {
            active.push(bookings[i]);
          }
          // }
          if ((['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(bookings[i].status) != -1) && userInfo.usertype == 'driver') {
            tracked = bookings[i];
            fetchBookingLocations(tracked.id)(dispatch);
          }
        }
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: {
            bookings: bookings.reverse(),
            active: active,
            tracked: tracked
          },
        });
        if (tracked) {
          dispatch({
            type: FETCH_BOOKINGS_SUCCESS,
            payload: null
          });
        }
      } else {
        dispatch({
          type: FETCH_BOOKINGS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_bookings,
        });
      }
    });
  }
  catch (e) {
    dispatch({
      type: FETCH_BOOKINGS_FAILED,
      payload: store.getState().languagedata.defaultLanguage.no_bookings,
    });
    console.error(e)
  }
};

export const onlyUpdateBooking = (booking: IBookingType) => async (dispatch: any) => {
  const {
    singleBookingRef,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  const { status, ...bookingWithoutStatus } = booking;

  update(singleBookingRef(booking.id), bookingWithoutStatus);
};


export const updateBooking = (booking: Partial<IBookingType>, settings?: ISettingsType | null) => async (dispatch: any) => {

  if (!booking.id) return;


  const {
    auth,
    trackingRef,
    singleUserRef,
    singleBookingRef,
  } = firebase;


  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  if (booking.status == 'PAYMENT_PENDING') {
    update(singleBookingRef(booking.id), booking);
  }

  if (booking.status == 'ARRIVED') {
    let dt = new Date();
    booking.driver_arrive_time = dt.getTime().toString();
    update(singleBookingRef(booking.id), booking);
    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          screen: 'BookedCab',
          params: { bookingId: booking.id },
          msg: store.getState().languagedata.defaultLanguage.driver_near,
          channelId: settings?.CarHornRepeat ? 'bookings-repeat' : 'bookings',
          title: store.getState().languagedata.defaultLanguage.notification_title,
        });
    }
  }

  if (booking.status == 'STARTED') {
    let dt = new Date();
    let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    let timeString = dt.getTime();
    booking.trip_start_time = localString;
    booking.startTime = timeString;

    update(singleBookingRef(booking.id), booking);

    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id), {
      status: 'STARTED',
      at: new Date().getTime(),
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          screen: 'BookedCab',
          params: { bookingId: booking.id },
          msg: store.getState().languagedata.defaultLanguage.driver_journey_msg,
          title: store.getState().languagedata.defaultLanguage.notification_title,
        });
    }
  }

  if (booking.status == 'REACHED') {
    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id), {
      at: new Date().getTime(),
      status: 'REACHED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });


    let bookingObj = await addActualsToBooking(booking as any);
    if (bookingObj) update(singleBookingRef(booking.id), bookingObj);

    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          screen: 'BookedCab',
          params: { bookingId: booking.id },
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.arrived_at_destination,
        });
    }
  }

  if (booking.status == 'PENDING') {
    update(singleBookingRef(booking.id), booking);
  }

  if (booking.status == 'PAID') {
    if (booking.booking_from_web) {
      booking.status = 'COMPLETE';
    }
    update(singleBookingRef(booking.id), booking);
    if (booking.driver == auth?.currentUser?.uid) {
      booking.driver && update(singleUserRef(booking.driver), { queue: false });
    }

    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          screen: 'BookedCab',
          params: { bookingId: booking.id },
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.success_payment,
        });
    }
  }

};

export const cancelBooking = (data: { cancelledBy: string; booking: IBookingType; reason: string }) => (dispatch: any) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef
  } = firebase;

  dispatch({
    type: CANCEL_BOOKING,
    payload: data,
  });

  update(singleBookingRef(data.booking.id), {
    status: 'CANCELLED',
    reason: data.reason,
    cancelledBy: data.cancelledBy
  }).then(() => {
    if (data.booking.driver && (data.booking.status === 'NEW' || data.booking.status === 'ACCEPTED' || data.booking.status === 'ARRIVED')) {
      update(singleUserRef(data.booking.driver), { queue: false });
      if (data.booking.customer_token) {
        RequestPushMsg(
          data.booking.customer_token,
          {
            screen: 'BookedCab',
            params: { bookingId: data.booking.id },
            msg: store.getState().languagedata.defaultLanguage.booking_cancelled,
            title: store.getState().languagedata.defaultLanguage.notification_title,
          });
      }
    }
    if (data.booking.status === 'NEW') {
      remove(requestedDriversRef(data.booking.id));
    }
  });
};

export const adminManualCompleteBooking = (booking: IBookingType) => async (dispatch: any) => {
  const { singleBookingRef, singleUserRef } = firebase;

  if (!booking.id) {
    throw new Error("Booking ID is required");
  }

  if (booking.status === 'COMPLETE' || booking.status === 'CANCELLED') {
    throw new Error(`Cannot complete booking with status: ${booking.status}`);
  }

  dispatch({
    type: UPDATE_BOOKING,
    payload: { ...booking, status: 'COMPLETE' },
  });

  const end_time = new Date();
  const timestamp = end_time.getTime();

  const updateData: Partial<IBookingType> = {
    status: 'COMPLETE',
    endTime: timestamp,
  };

  await update(singleBookingRef(booking.id), updateData);

  if (booking.driver) {
    await update(singleUserRef(booking.driver), { queue: false });
  }

  return updateData;
};